module.exports = __webpack_public_path__ + "img/camera_color.7e785724.svg";